import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import debounce from 'lodash/debounce';
import $ from 'jquery';

/**
 * Component that creates the slide panels
 */
class SlidingPanels extends Component {
    constructor(props) {
        super(props);
        this.renderStyle = this.renderStyle.bind(this);
        this.renderRadioButton = this.renderRadioButton.bind(this);
        this.renderSlice1 = this.renderSlice1.bind(this);
        this.renderSlice2 = this.renderSlice2.bind(this);
        this.renderSlice3 = this.renderSlice3.bind(this);
        this.renderSlice4 = this.renderSlice4.bind(this);
        this.renderTitles = this.renderTitles.bind(this);
        this.tick = this.tick.bind(this);

        this.state = {
            isMobile: window.innerWidth < 768 && window.innerWidth < window.innerHeight,
            height: 640,
            sliceWidth: window.innerWidth / 4,
            visibility: 'hidden',
            selectedIndex: 0
        };

        this.interval = setInterval(() => this.tick(), 5000);
    }

    tick() {
        if (document.querySelectorAll('.cr-container input').length > 1) {
            // get next slide and select it.
            if (this.state.selectedIndex >= this.props.slides.length - 1) { // last slide
                this.setState({
                    selectedIndex: 0
                });
            }
            else {
                this.setState({
                    selectedIndex: this.state.selectedIndex + 1
                });
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $(window).off('resize');
    }

    get isAboutPage() {
        return this.props.location.pathname === '/about';
    }

    componentDidMount() {
        // this.setState({ slides: document.querySelectorAll('.cr-container input').length });
        
        const calculateLayout = function () {
            const isMobile = window.innerWidth < 768 && window.innerWidth < window.innerHeight && !this.isAboutPage;
            const height = (window.innerWidth / (isMobile ? 960 : 1920) * 640);
            if (ReactDOM.findDOMNode(this)) {
                this.setState({
                    'height' : height,
                    'sliceWidth': window.innerWidth / (isMobile ? 2 : 4),
                    'isMobile': isMobile,
                    'visibility': 'visible'
                });
            }
        }.bind(this);
        const lazyLayout = debounce(calculateLayout, 300);
        $(window).resize(lazyLayout);
        $(window).resize();
    }

    // region render methods
    renderStyle(slide, index) {
        return (
            <style key={index}>
                {
                    `.cr-container input.cr-selector-img-${index}:checked ~ cr.bgimg {
                    background-image: url(${slide.image});
                  }`
                }
            </style>
        )
    }

    renderRadioButton(slide, index) {
        return (
            <input key={index} type="radio"
                   id={'select-img-' + index}
                   name="radio-set"
                   className={'hidden-xs cr-selector-img-' + index}
                   checked={this.state.selectedIndex === index}
                   readOnly
            />
        )
    }

    renderSlice1(slide, index) {
        return (
            <span key={index} style={{
                backgroundPosition: `${(-1 * this.state.sliceWidth * 0)}px 0`,
                backgroundImage: `url(${slide.image})`
            }}>{`Slice 1 - Image ${index}`}</span>
        );
    }

    renderSlice2(slide, index) {
        return (
            <span key={index} style={{
                backgroundPosition: `${(-1 * this.state.sliceWidth * 1)}px 0`,
                backgroundImage: `url(${(this.state.isMobile ? slide.image.replace('f_auto', 'c_scale,f_auto,w_768') : slide.image)})`
            }}>{`Slice 2 - Image ${index}`}</span>
        );
    }

    renderSlice3(slide, index) {
        return (
            <span key={index} style={{
                backgroundPosition: `${(-1 * this.state.sliceWidth * 2)}px 0`,
                backgroundImage: `url(${(this.state.isMobile ? slide.image.replace('f_auto', 'c_scale,f_auto,w_768') : slide.image)})`
            }}>{`Slice 3 - Image ${index}`}</span>
        );
    }

    renderSlice4(slide, index) {
        return (
            <span key={index} style={{
                backgroundPosition: `${(-1 * this.state.sliceWidth * 3)}px 0`,
                backgroundImage: `url(${slide.image})`
            }}>{`Slice 4 - Image ${index}`}</span>
        );
    }

    renderTitles(slide, index) {
        return (
            <h3 key={index}>
                <span className={slide.headline === '' ? 'hidden' : ''}>{slide.headline}</span>
                <span className={slide.subline === '' ? 'hidden' : ''}>{slide.subline}</span>
            </h3>
        );
    }

    // endregion

    render() {
        const { slides } = this.props;

        return (
            <section className="cr-container" style={{ height: `${this.state.height}px` }}>
                {slides.map(this.renderStyle)}
                {slides.map(this.renderRadioButton)}
                <div className="clr"></div>
                {/* slices */}
                <div className={`cr-bgimg ${this.isAboutPage ? 'about' : ''}`} style={{ height: `${this.state.height}px` }}>
                    {
                        this.state.isMobile ?
                            '' :
                            <div>
                                {slides.map(this.renderSlice1)}
                            </div>
                    }
                    <div>
                        {slides.map(this.renderSlice2)}
                    </div>
                    <div>
                        {slides.map(this.renderSlice3)}
                    </div>
                    {
                        this.state.isMobile ?
                            '' :
                            <div>
                                {slides.map(this.renderSlice4)}
                            </div>
                    }
                </div>
                {/* titles */}
                <div className="cr-titles">
                    {slides.map(this.renderTitles)}
                </div>
            </section>
        );
    }
}

export default SlidingPanels;


// WEBPACK FOOTER //
// ./src/components/SlidingPanels.js